import { IGenericSelectOption } from '../types/forms';
const langOpts = {
	english: 'en',
	french: 'fr'
};

const currencyOpts: IGenericSelectOption[] = [
	{
		label: 'CAD',
		value: 'cad'
	},
	{
		label: 'USD',
		value: 'usd'
	}
];

export { langOpts, currencyOpts };
